import React, { useLayoutEffect, useRef } from 'react';
import * as StatsActions from '../../actions/StatsActions'

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4plugins_venn from "@amcharts/amcharts4/plugins/venn"; 
import am4themes_dark from "@amcharts/amcharts4/themes/dark";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_dark);
am4core.useTheme(am4themes_animated);

export interface IVennDiagramChartDataItem {
    name: string;
    value: number;
    tooltipText: string;
    sets: string[] | null;
  }

export interface IVennDiagramChartProps {
    id: string;
    data: IVennDiagramChartDataItem[];
  }

const VennDiagramChart: React.FC<IVennDiagramChartProps> = (props: IVennDiagramChartProps) => {
    const chart = useRef();

    useLayoutEffect(() => {
        let c = am4core.create(`${props.id}`, am4plugins_venn.VennDiagram);

        chart.current = c as any;

        let data = props.data.map(item => {
            let result: any = {
                name: item.name,
                value: item.value,
                tooltipText: item.tooltipText,
            }

            if (item.sets != null) {
                result.sets = item.sets;
            }

            return result;
        })

        let series = c.series.push(new am4plugins_venn.VennSeries())

        series.dataFields.category = "name";
        series.dataFields.value = "value";
        series.dataFields.intersections = "sets";
        series.data = data;
        series.labels.template.text = "{tooltipText}"

        series.slices.template.tooltipText = "{name}"
    
        return () => {
            c.dispose();
        };
      }, [props]);
    
    return (
        <div className="VennDiagramChart" id={props.id} style={{ width: "100%", height: "500px" }}></div>
    );
  }
  
  export default VennDiagramChart;